import { createContext } from "react";

export const NewProjectContext = createContext<any>({ template: null });
